import { BaseMatcher, Matcher } from './base.matcher';
import { notNull } from './not-null.matcher';
import { notUndefined } from './not-undefined.matcher';

export function isDefined<T>(message: () => string = () => 'value must be defined'): Matcher<T> {
  return new BaseMatcher<T>((input) => {
    return notNull().apply(input) && notUndefined().apply(input);
  }, message);
}
